export default __webpack_public_path__ + "static/media/PowerGrotesk-Italic.180a7421.otf";